import React, { Component } from "react";
import {
    Typography,
    Grid,
    IconButton,
    Button,
    ButtonGroup,
} from "@material-ui/core";
import { hot } from "react-hot-loader";
import { connect } from "react-redux";
import BarChart from "./BarChart";
import { Divider } from "@material-ui/core";
import {
    getReportTypes,
    getUsers,
    setYear,
    setMonth,
    setFilterType,
    setFilterUserUid,
} from "./actions";
import {
    selectData,
    selectYear,
    selectMonth,
    selectDateFilterType,
    getRequesting,
    selectRegisteredUsers,
    selectUserReportsData,
    selectFilterUserUid,
} from "./selectors";

import LeftIcon from "@material-ui/icons/ArrowLeft";
import RightIcon from "@material-ui/icons/ArrowRight";
import moment from "moment";

class UserPerformanceTab extends Component {
    render() {
        const { data, filterType, month, year } = this.props;
        return (
            <>
                <Typography variant="h5">Date Range Picker</Typography>
                <ButtonGroup>
                    <Button
                        style={{
                            background:
                                filterType === false ? "#0188cc" : "inherit",
                            color: filterType === false ? "white" : "black",
                        }}
                        variant="contained"
                        onClick={() => {
                            this.props.setFilterType(false);
                        }}
                    >
                        None
                    </Button>
                    <Button
                        style={{
                            background:
                                filterType === "month" ? "#0188cc" : "inherit",
                            color: filterType === "month" ? "white" : "black",
                        }}
                        variant="contained"
                        onClick={() => {
                            this.props.setFilterType("month");
                        }}
                    >
                        Month/Year
                    </Button>
                    <Button
                        style={{
                            background:
                                filterType === "year" ? "#0188cc" : "inherit",
                            color: filterType === "year" ? "white" : "black",
                        }}
                        variant="contained"
                        onClick={() => {
                            this.props.setFilterType("year");
                        }}
                    >
                        Year
                    </Button>
                </ButtonGroup>
                <Grid container spacing={0} style={{ width: "60%" }}>
                    {filterType === "month" && (
                        <Grid item xs={6}>
                            <Grid
                                container
                                spacing={2}
                                style={{ width: "30%" }}
                            >
                                <Grid item xs={3}>
                                    <IconButton
                                        onClick={() => {
                                            this.props.setMonth(
                                                month === 0 ? 11 : month - 1
                                            );
                                        }}
                                    >
                                        <LeftIcon />
                                    </IconButton>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography
                                        align={"center"}
                                        style={{ paddingTop: 12 }}
                                        variant={"body1"}
                                    >
                                        {moment().month(month).format("MMMM")}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <IconButton
                                        onClick={() => {
                                            this.props.setMonth(
                                                month === 11 ? 0 : month + 1
                                            );
                                        }}
                                    >
                                        <RightIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                    {(filterType === "month" || filterType === "year") && (
                        <Grid item xs={6}>
                            <Grid
                                container
                                spacing={2}
                                style={{ width: "30%" }}
                            >
                                <Grid item xs={3}>
                                    <IconButton
                                        onClick={() => {
                                            this.props.setYear(
                                                Number(year) - 1
                                            );
                                        }}
                                    >
                                        <LeftIcon />
                                    </IconButton>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography
                                        align={"center"}
                                        variant={"body1"}
                                        style={{ paddingTop: 12 }}
                                    >
                                        {Number(year)}
                                    </Typography>
                                </Grid>
                                <Grid item xs={3}>
                                    <IconButton
                                        onClick={() => {
                                            this.props.setYear(
                                                Number(year) + 1
                                            );
                                        }}
                                    >
                                        <RightIcon />
                                    </IconButton>
                                </Grid>
                            </Grid>
                        </Grid>
                    )}
                </Grid>

                <br />
                <Divider style={{ marginTop: 12 }} />
                <Grid container spacing={24} style={{ paddingBottom: 50 }}>
                    {data &&
                        data.map((e, i) => {
                            return (
                                <Grid
                                    item
                                    xs={4}
                                    xl={4}
                                    key={i}
                                    style={{ maxHeight: 400 }}
                                >
                                    <BarChart
                                        style={{ position: "relative" }}
                                        key={i}
                                        title={e.title}
                                        chartData={e.data}
                                    />
                                    <br />
                                </Grid>
                            );
                        })}
                </Grid>
                <br />
            </>
        );
    }
}
export default hot(module)(
    connect(
        (store) => {
            return {
                data: selectData(store),
                month: selectMonth(store),
                year: selectYear(store),
                filterType: selectDateFilterType(store),
                requesting: getRequesting(store),
                user: selectRegisteredUsers(store),
                userDetails: selectUserReportsData(store),
                selectedUser: selectFilterUserUid(store),
            };
        },
        {
            getReportTypes,
            getUsers,
            setMonth,
            setYear,
            setFilterType,
            setFilterUserUid,
        }
    )(UserPerformanceTab)
);
